module.exports = __webpack_public_path__ + "img/vr_m_5.74df0355.jpg";